import http from './http-common';
import config from '../appconfig/config.json';
import storage from '../factory/StorageFactory';

const uploadFiles = (selectedFile,refNo,docName,type,id) => {

    const data = new FormData();
    data.append('files', selectedFile)
 
    
    let stateId = storage.getStateId(); 

    return http.post(`/api/v1/SME/upload/${stateId}/${refNo}/${docName}/${type}/${id}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        'Authorization': "Maybank "+ storage.getToken()
      }
    });
}

const uploadB64ImgFile = (b64ImgStr,refNo,docName,type,ext,id) => {

  let data = {
    "ImageFile":b64ImgStr
  }
 
  let stateId = storage.getStateId();
  return http.post(`/api/v1/SME/uploadBase64Image/${stateId}/${refNo}/${docName}/${type}/${ext}/${id}`, data, {
    headers: {
      "Content-Type": "application/json",
      'Authorization': "Maybank "+ storage.getToken()
    }
  });
}

const getFiles = (refNo,type) => {
    return http.get("/files");
 }

 const getFile = (refNo,type,id) => {
  let stateId = storage.getStateId();
  return http.get(`/api/v1/SME/getUpload/${stateId}/${refNo}/${type}/${id}`, {
    headers: {
      "Content-Type": "application/json",
      'Authorization': "Maybank " +storage.getToken()
    }
  });
}

const getPdfFileUrl = (refNo,type,id,name) => {
  let stateId = storage.getStateId(); 

  let apiUrl = '';
  switch (config.SERVER_STATUS) {
      case "DEV": apiUrl = config.SmeApi.DEV
      break;
      case "SIT": apiUrl = config.SmeApi.SIT 
      break;
      case "UAT": apiUrl = config.SmeApi.UAT 
      break;
      case "PROD": apiUrl = config.SmeApi.PROD 
      break;
      case "SIM": apiUrl = config.SmeApi.SIM 
      break;
      default:
      break;
  }
 
  const url = apiUrl+`/api/v1/SME/getUploadPDF/${stateId}/${refNo}/${type}/${id}/${name}`;
  
  return url;
}
 
export default {
    uploadFiles,
    getFiles,
    getFile,
    getPdfFileUrl,
    uploadB64ImgFile
}